// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1eeOy","productName":"Table_productName__15TVL"};